import React from 'react'
import profileImg from '../../../assets/images/profileImg.svg'
import { hasMembershipType } from '../../utils'
import { getMemberStatusLabel } from './utils'
import {
  Container,
  ProfileImage,
  ContentWrapper,
  LeftSection,
  ProfileInfo,
  NameRow,
  Name,
  Badge,
  Details,
  SectionName,
  FacilityName,
  MemberId,
  EditLink,
  EditText
} from './Styles/ProfileBrief.styles'

const ProfileBrief = ({ me, levelState, onEditClick, authReady }) => {
  if (!authReady || !me) return null

  const displayName = me.displayName || `${me.firstName} ${me.lastName}`
  const badgeText = getMemberStatusLabel(levelState)

  return (
    <Container>
      <ProfileImage 
        src={me.profilePhoto || me.photo || profileImg} 
        alt={displayName}
      />
      <ContentWrapper>
        <LeftSection>
          <ProfileInfo>
            <NameRow>
              <Name>{displayName}</Name>
              <Badge>{badgeText}</Badge>
            </NameRow>
            <Details>
              {me.section && (
                <SectionName>{me.section.name}</SectionName>
              )}
              {me.primaryFacility && (
                <FacilityName>{me.primaryFacility.name}</FacilityName>
              )}
              {hasMembershipType(me) && (
                <MemberId>Member ID: #{me.id}</MemberId>
              )}
            </Details>
          </ProfileInfo>
        </LeftSection>
        {hasMembershipType(me) && (
          <EditLink onClick={onEditClick || (() => window.location.href = '/profile/edit')}>
            <EditText>Edit My Profile</EditText>
            <i className='fa fa-angle-right' style={{ color: '#0082CE' }} />
          </EditLink>
        )}
      </ContentWrapper>
    </Container>
  )
}

export default ProfileBrief
